/**
 * How the admin app names people and teams. A person never reads an internal id: when the wire
 * carries no name, the screen says so in these words instead of printing the id.
 */

export const UNKNOWN_USER = "Unknown user";
export const UNKNOWN_TEAM = "Unknown team";
/** Any other target the API could not name: gone, erased, or of a type that has no name. */
export const UNKNOWN_TARGET = "Unknown target";

export interface PersonNameParts {
  displayName?: string | null | undefined;
  email?: string | null | undefined;
  externalId?: string | null | undefined;
}

/** The display name, else the email, else the IdP's external id, else "Unknown user". */
export function personName({ displayName, email, externalId }: PersonNameParts): string {
  return displayName?.trim() || email?.trim() || externalId?.trim() || UNKNOWN_USER;
}

/** The team's name, else "Unknown team". */
export function teamName(name: string | null | undefined): string {
  return name?.trim() || UNKNOWN_TEAM;
}
